const $ = require('jquery');

class MTUISelect {
  constructor (id) {
    this.id = id;
    this.$wrapper = $(`#${id}`);
    this.$value = this.$wrapper.find('.mtui-select__value');
    this.$input = this.$wrapper.find('input');
    this.changeListeners = [];
    this.initChangeEvent();
    this.initOpenEvent();
  }

  change(callback) {
    this.changeListeners.push(callback);
  }

  insertData(data) {
    const $options = this.$wrapper.find('.mtui-select__options');
    $options.empty();
    data.forEach((item) => {
      $options.append(`<div class="mtui-select__option" data-value="${item.id}">${item.name}</div>`);
    });
    this.$input.val('');
    this.$value.html('');
    this.initChangeEvent();
    this.changeListeners.forEach((callback) => callback(null, null));
  }

  initOpenEvent () {
    const _this = this;
    this.$wrapper.click(function () {
      if ($(this).hasClass('opened')) {
        $(this).removeClass('opened');
      } else {
        $(this).addClass('opened');
      }
    })
    $(document).on('click', function (e) {
      const target = e.target;
      if ($(target).closest(`#${_this.id}`).length === 0 && $(target).attr('id') != _this.id) _this.$wrapper.removeClass('opened')
    });

    this.$wrapper.find('.mtui-select__clear').click((e) => {
      e.stopPropagation();
      this.$value.html(null);
      this.$input.val(null);
      this.changeListeners.forEach((callback) => callback(null, null));
      return false;
    })
  }

  initChangeEvent () {
    const _this = this;
    this.$wrapper.find('.mtui-select__option').click(function () {
      const value = $(this).data('value');
      const name = $(this).html();
      _this.$value.html(name);
      _this.$input.val(value);
      _this.changeListeners.forEach((callback) => callback(value, name));
    })
  }
}

const selectInit = function () {
  window.MTUIElements ||= {};
  $('.mtui-select__wrapper').each(function () {
    const id = $(this).attr('id');
    window.MTUIElements[id] = new MTUISelect(id);
  })
}

export {selectInit}
